import { Button, ButtonProps } from "@mui/material";
import React from "react";
import { ModalContext } from "..";
import ModalConfirmAction, { ModalConfirmActionElementProps } from "./modal-confirm-action";

export interface ModalConfirmActionOpenButtonProps extends ButtonProps {
  displayComment?: boolean;
  modalMessage: string;
  onConfirm?: (comment?: string) => void;
}

const ModalConfirmActionOpenButton: React.FC<ModalConfirmActionOpenButtonProps> = (props) => {
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const { displayComment, modalMessage, onConfirm, children, ...otherProps } = props;

  const handleButtonClick: React.MouseEventHandler = () => {
    if (!openModal) {
      return;
    }

    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      displayComment: displayComment,
      title: modalMessage,
      onConfirm,
    });
  };

  return (
    <Button {...otherProps} onClick={handleButtonClick}>
      {children}
    </Button>
  );
};

export default ModalConfirmActionOpenButton;
